module.exports = __webpack_public_path__ + "_/public/new.gif?8d8c0cc5";


//////////////////
// WEBPACK FOOTER
// ../public/new.gif
// module id = 652
// module chunks = 0